import React from 'react'
import classes from '../Sidebar.module.scss'

type Props = React.HTMLProps<HTMLDivElement> & {
  icon?: React.ReactNode
}

const MenuItemAction: React.FC<Props> = ({
  children,
  className,
  icon,
  ...props
}) => {
  return (
    <div
      className={`${classes.menuItemAction}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {!!icon &&
        <span
          className={classes.menuItemActionIcon}
        >
          {icon}
        </span>
      }
      {children}
    </div>
  )
}

export default MenuItemAction
